import { useEffect } from 'react';

import { useBannerTypeContext } from '../context/BannerTypeContext';

type BannerType =
    | 'bannerZero'
    | 'bannerOne'
    | 'bannerTwo'
    | 'bannerThree'
    | 'bannerFour'
    | 'bannerFive'
    | 'none';

const useSetBannerType = (type: BannerType) => {
    const { setBannerType } = useBannerTypeContext();

    useEffect(() => {
        setBannerType(type);
    }, [type, setBannerType]);
};

export default useSetBannerType;
